import React, { FC } from 'react';
import { Box, SxProps, Typography } from '@mui/material';

import WithSkeleton from '../../../common/WithSkeleton';

import classes from './style';

interface IPriceLabel {
  title: string;
  price: string | number | boolean | undefined | null;
  counterPrice?: string | number | boolean;
  successAction: string;
  customStyle?: SxProps;
}

const PriceLabel: FC<IPriceLabel> = ({
  title,
  price,
  counterPrice,
  successAction,
  customStyle = {},
}) => {
  const styleConfig = counterPrice
    ? {
      price: classes.strike,
      counterPrice: classes.pharmacyCounterPrice,
    }
    : {
      price: classes.price,
      counterPrice: {},
    };

  const SkeletonTypography = WithSkeleton({
    successAction,
    variant: 'text',
  })(Typography);

  return (
    <Box sx={classes.root}>
      <Box sx={classes.titleContainer}>
        <SkeletonTypography sx={classes.title}>{title}</SkeletonTypography>
        <Box sx={classes.priceContainer}>
          <SkeletonTypography sx={[styleConfig.price, customStyle]}>
            {price}
          </SkeletonTypography>
          <SkeletonTypography sx={styleConfig.counterPrice}>
            {counterPrice}
          </SkeletonTypography>
        </Box>
      </Box>
    </Box>
  );
};

export default PriceLabel;
